// src/pages/billing/SuccessPayment.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import "../styles/Billing.css"; // ← reuse the same beautiful style system

const SuccessPayment: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="billing-page">
      <div className="billing-container" style={{ maxWidth: "650px" }}>
        
        <div className="billing-card" style={{ textAlign: "center" }}>
          
          {/* SUCCESS ICON */}
          <div
            className="success-icon-wrapper"
            style={{
              background: "#ecfdf5",
              width: "110px",
              height: "110px",
              borderRadius: "999px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #a7f3d0",
              animation: "popIn 0.5s ease-out",
            }}
          >
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-green-600"
              style={{ fontSize: "70px" }}
            />
          </div>

          {/* TITLE */}
          <h1
            className="billing-header-title"
            style={{ marginTop: "1rem", marginBottom: "0.5rem", textAlign: "center" }}
          >
            Payment Successful 🎉
          </h1>

          <p className="billing-header-subtitle" style={{ textAlign: "center" }}>
            Thanks for upgrading! Your premium subscription is now active.
            A confirmation email has been sent to you.
          </p>

          {/* BUTTONS */}
          <div className="billing-stack" style={{ marginTop: "2rem" }}>
            <button
              className="billing-button billing-button--primary"
              onClick={() => navigate("/dashboard")}
            >
              Go to Dashboard
            </button>

            <button
              className="billing-button billing-button--outline"
              onClick={() => navigate("/billing")}
            >
              Manage Billing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPayment;
